export default {
    fields: {
        productName: 'Product name',
        sku: 'Local product code',
        barcode: 'Product barcode',
        skuQuantity: 'Ordered by the client / Reserve',
        skuQuantityAdaptive: 'Ordered/ Collected',
        skuQuantityFinished: 'Collected',
        productPrice: 'Price per piece., %currencyAbbreviation%',
        productSumPrice: 'The amount, %currencyAbbreviation%',
        productCommentCooperator: 'Comment on the position of the call center',
        productCommentWorker: 'Comment on the position of the store employee',
        productProperties: 'Product Features',
        productCommentClient: 'Comment on the position',
        pic: 'Image',
        actions: 'Confirmation',
        refundQuantity: 'The returned quantity of the product',
        totalRefundPrice: 'The total amount of the refund for the item',
        productWeight: 'Weight',
        exchangeQuantity: 'Quantity of goods to be exchanged',
        refundSkuQuantityFinished: 'Quantity of goods sold to the customer',
        exchangeSkuQuantityFinished: 'Quantity of goods sold to the customer',
    },

    productsTable: {
        span: [
            'Ordered (products):',
            '[Paid for]',
            'Total (products):',
            'Shipping cost (from the order):',
            'Discount on the promotion:',
            'Package price (from the order):',
            'Total (including package):',
            'Total payable:',
            'Promo code discount:',
        ],
        totalText: 'Total collected (including shipping):',
        totalWithDiscount: 'Total collected (including rebate and shipping):',
        totalWithPackages: 'Total Collected (including discount, shipping and packages):',
        totalWithDicountAndPackages: 'Total collected (including rebate, packages and shipping):',
        totalPayable: 'Total payable:',
        titleProducts: 'Product list',
        totalTitle: 'Summary Information',
        pointsWrittenOffTitle: 'Points written off:',
        bonusTitle: 'Loyalty program',
        bonusDelta: 'Accrued/written off points for the purchase:',
        bonusActivePoints: 'Active points:',
        bonusInactivePoints: 'Inactive Points:',
        bonusUpdateTime: 'Date of the last update of the status of the bonus account:',
    },

    skuQuantityTare: 'Add | packaging containers | Quantity | Add',
    add: 'Add',
    finished: 'Collected',
    markScanning: 'Сканирование марки',

    // eslint-disable-next-line max-len
    addToTareExceptions: 'Incorrect data in the request, please try refreshing the page by clicking the refresh icon or pressing F5 on your keyboard. If the problem persists, please contact support',
};